// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Bypn","validationTips":"StatementDescriptor_validationTips__1Jlfk"};